import type { TestProcedureRow } from '#shared/types';
import type { Column } from '#client/components/ui/DataTable';

/** The SOP library's columns, at module scope like every other column array. */
export const procedureColumns: Column<TestProcedureRow>[] = [
  {
    key: 'title',
    header: 'Procedure',
    frozen: true,
    render: (row) => (
      <div>
        <strong>{row.title}</strong>
        <div className="c-muted">{row.lab_test?.name ?? row.parameter?.name ?? 'Not attached'}</div>
      </div>
    ),
  },
  {
    key: 'level',
    header: 'Level',
    width: '9rem',
    render: (row) => (row.lab_test ? 'Whole test' : 'One analyte'),
  },
  {
    key: 'method',
    header: 'Method',
    render: (row) => row.method ?? <span className="c-muted">—</span>,
  },
  {
    key: 'steps',
    header: 'Steps',
    align: 'end',
    width: '6rem',
    render: (row) => row.procedure_steps.length,
  },
  {
    key: 'version',
    header: 'Version',
    align: 'end',
    width: '6rem',
    render: (row) => row.version,
  },
];
